function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M16.818 8.33l1.569 17.93 23.908-2.09-1.568-17.932-23.909 2.091zm-.261-2.99L40.465 3.25a3 3 0 0 1 3.25 2.727l1.569 17.932a3 3 0 0 1-2.727 3.25l-23.909 2.091a3 3 0 0 1-3.25-2.727L13.83 8.591a3 3 0 0 1 2.728-3.25zm6.051 17.54a1.5 1.5 0 0 1-.261-2.989l2.988-.261a1.5 1.5 0 0 1 .262 2.989l-2.989.261zm-9.674 9.902l28.503-2.494a1.5 1.5 0 0 1 .261 2.989l-31.49 2.755L7.46 4.63a1.5 1.5 0 1 1 2.989-.262l2.485 28.413zM9.347 8.983a1.5 1.5 0 0 1 .261 2.989l-5.977.522a1.5 1.5 0 1 1-.262-2.988l5.978-.523zm4.37 32.744a3 3 0 1 0-.523-5.978 3 3 0 0 0 .523 5.978zm.261 2.988a6 6 0 1 1-1.045-11.954 6 6 0 0 1 1.045 11.954zM32.134 9.262l-.392-4.483 2.988-.261.61 6.973a.5.5 0 0 1-.454.542l-10.958.959a.5.5 0 0 1-.542-.455l-.61-6.973 2.988-.262.393 4.483 5.977-.523z"
});

var SvgPickup = function SvgPickup(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgPickup;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/pickup.svg
// module id = 147
// module chunks = 0 1